// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"31905de5","453":"8ab44547","806":"cd56f753"}[chunkId] + ".chunk.js";
};